export const MAX_ASSOCIATED_LORA_DEVICES: number = 11;

export const OFFSET_MAX_CM: number = 600;
export const OFFSET_MAX_IN: number = 240;
export const OFFSET_MIN_CM: number = -600;
export const OFFSET_MIN_IN: number = -240;

export const BORE_MAX_DEPTH_M: number = 300;
export const BORE_MAX_DEPTH_FT: number = 1000;

export const DAM_MAX_DEPTH_M = 100;
export const DAM_MAX_DEPTH_FT = 300;
export const DAM_MAX_DEPTH_IN = 3600;
export const DAM_MAX_DEPTH_CM = 10_000;

export const LINE_PRESSURE_MAX_KPA: number = 4000;
export const LINE_PRESSURE_MAX_PSI: number = 600;

export const TROUGH_MAX_HEIGHT_CM: number = 125;
export const TROUGH_MAX_HEIGHT_IN: number = 50;

export const TROUGH_DIRECT_DEFAULT_HEIGHT_CM: number = 15;
export const TROUGH_DIRECT_DEFAULT_HEIGHT_IN: number = 6;

export const TANK_HEIGHT_WARNING_THRESHOLD_CM: number = 900;
export const TANK_HEIGHT_WARNING_THRESHOLD_IN: number = 354;

export const DEFAULT_PRECISION_IMPERIAL: number = 2;
export const DEFAULT_PRECISION_METRIC: number = 1;
/** Avoid losing precision in multi-step conversions */
export const INTERMEDIARY_PRECISION: number = 4;
export const TANK_LEVEL_PRECISION: number = 1;
export const TANK_VOLUME_PRECISION: number = 0;
export const DAM_PRECISION: number = 2;
export const LINE_PRESSURE_PRECISION: number = 1;
export const BORE_LEVEL_PRECISION: number = 2;
// Cannot be higher because the trigger precision is limited to 0.01 m by BE.
// For example, 3.22 ft is 0.98m (0.9815m) but 3.23 ft is also 0.98m (0.9845m).
export const BORE_LEVEL_TRIGGER_PRECISION_IMPERIAL: number = 1;
export const PIPE_VOLUME_PRECISION_IMPERIAL: number = 1;
export const PIPE_VOLUME_PRECISION_METRIC: number = 0;
export const PIPE_VOLUME_PER_TICK_PRECISION: number = 3;
export const WIRELESS_TROUGH_LEVEL_PRECISION: number = 1;
export const TROUGH_DIRECT_PRECISION: number = 1;

export const MIDNIGHT_HOUR: number = 0;
export const LEGACY_DAILY_RAINFALL_RESET_HOUR: number = MIDNIGHT_HOUR;
export const DEFAULT_DAILY_RAINFALL_RESET_HOUR: number = 9;
export const DEFAULT_DAILY_RAINFALL_RESET_HOUR_US: number = 7;

export const DAILY_RAINFALL_RESET_TIME_OPTIONS = [
  {
    label: '12:00 AM',
    value: LEGACY_DAILY_RAINFALL_RESET_HOUR
  },
  {
    label: '1:00 AM',
    value: 1
  },
  {
    label: '2:00 AM',
    value: 2
  },
  {
    label: '3:00 AM',
    value: 3
  },
  {
    label: '4:00 AM',
    value: 4
  },
  {
    label: '5:00 AM',
    value: 5
  },
  {
    label: '6:00 AM',
    value: 6
  },
  {
    label: '7:00 AM',
    value: 7
  },
  {
    label: '8:00 AM',
    value: 8
  },
  {
    label: '9:00 AM',
    value: 9
  },
  {
    label: '10:00 AM',
    value: 10
  },
  {
    label: '11:00 AM',
    value: 11
  },
  {
    label: '12:00 PM',
    value: 12
  },
  {
    label: '1:00 PM',
    value: 13
  },
  {
    label: '2:00 PM',
    value: 14
  },
  {
    label: '3:00 PM',
    value: 15
  },
  {
    label: '4:00 PM',
    value: 16
  },
  {
    label: '5:00 PM',
    value: 17
  },
  {
    label: '6:00 PM',
    value: 18
  },
  {
    label: '7:00 PM',
    value: 19
  },
  {
    label: '8:00 PM',
    value: 20
  },
  {
    label: '9:00 PM',
    value: 21
  },
  {
    label: '10:00 PM',
    value: 22
  },
  {
    label: '11:00 PM',
    value: 23
  }
];
